import { render, staticRenderFns } from "./WeekList.vue?vue&type=template&id=77d746c4&scoped=true"
import script from "./WeekList.vue?vue&type=script&lang=js"
export * from "./WeekList.vue?vue&type=script&lang=js"
import style0 from "./WeekList.vue?vue&type=style&index=0&id=77d746c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d746c4",
  null
  
)

export default component.exports